module.exports = __webpack_public_path__ + "ecs.logo.83b41.svg";


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/ecs/logo/ecs.logo.svg
// module id = 3970
// module chunks = 0